import { useCallback, useContext, useEffect, useMemo, useRef, useState } from "react"
import services from "../../../services/services";
import { Urls } from "../../../services/Urls";
import { useCommon } from "../../Common/useCommon";
import _ from "underscore";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { callautopopulate } from "../../../services/callautopop";
import { dateConvert, dateHoverRange } from "../../../utils/Helper";
import { ToastContext } from "../../../context/ToastContext";
import { useProdServiceBuild } from "./useProdServiceBuild";
import { DateObject } from "react-multi-date-picker";

export const useProdServiceBuildList = () => {

    const tagRef = useRef(null);
    const { showSuccess, showInfo, showError } = useContext(ToastContext);
    const { getValuePermission } = useCommon();
    const [dropDownOption, setDropDownOption] = useState({ statusOptions: [], users: [], projects: [], roleOpts: [], build_type: [], jenkins_type: [] });
    const [filterValues, setFilterValues] = useState({ project: [], users: [], build_type: [], jenkins_type: [], hoveredRange: [new DateObject().subtract(8, "days"), new DateObject().add(0, "days"),], isChange: false });
    const [showRequestPopup, setShowRequestPopup] = useState(false);
    const [editData, setEditData] = useState({});
    const [loader, setLoader] = useState({ grid: false, btn: false });
    const [showApprovePopup, setShowApprovePopup] = useState(false);
    const [approval, setApproval] = useState({ status: '', data: "", from_date: null, to_date: null, build_date: null });
    const [rowData, setRowData] = useState([]);
    const savedCols = JSON.parse(localStorage.getItem("prod_build_column_order") || "[]");
    const columnDef = [
        {
            field: "edit",
            headerName: "Edit",
            width: 40,
            cellStyle: { textAlign: "center" },
            headerClass: "ag-text-center",
            displayOrder: _.indexOf(savedCols, _.findWhere(savedCols, { colId: "edit" })) !== -1 ? _.indexOf(savedCols, _.findWhere(savedCols, { colId: "edit" })) : 1,
            hide: (filterValues?.status?.request_status_id !== _.findWhere(dropDownOption?.statusOptions, { request_status_key: "is_pending" })?.request_status_id && filterValues?.status?.request_status_id !== _.findWhere(dropDownOption?.statusOptions, { request_status_key: "is_approved" })?.request_status_id),
            cellRenderer: (params) => {
                const devOpsUserCodes = _.pluck(approval?.devops_approver, "user_code");
                const pendingId = _.findWhere(dropDownOption?.statusOptions, { request_status_key: "is_pending" })?.request_status_id;
                const approveId = _.findWhere(dropDownOption?.statusOptions, { request_status_key: "is_approved" })?.request_status_id;
                let showEdit = false;
                if (devOpsUserCodes?.includes(dropDownOption?.userCode) || ((params?.data?.requested_user_code === dropDownOption?.userCode) && !params?.data?.approve2_datetime)) {
                    showEdit = true;
                }

                let approveStatus = { stage: "", action_by: devOpsUserCodes?.includes(dropDownOption?.userCode) ? "devops" : params?.data?.requested_user_code === dropDownOption?.userCode ? "requester" : params?.data?.client_user_code === dropDownOption?.userCode ? "client" : "" };
                if (params?.data?.approve1_datetime && !params?.data?.approve2_datetime) {
                    approveStatus = { ...approveStatus, stage: "approve1" }
                } else if (params?.data?.approve1_datetime && params?.data?.approve2_datetime) {
                    approveStatus = { ...approveStatus, stage: "approve2" }
                }
                return <div>{showEdit && (filterValues?.status?.request_status_id === pendingId || filterValues?.status?.request_status_id === approveId) ?
                    <div style={{ cursor: "pointer" }}><FontAwesomeIcon icon="fa-solid fa-pen-to-square" onClick={() => { setShowRequestPopup(true); setEditData({ ...params?.data, approve_status: approveStatus }) }} /></div> :
                    <></>}</div>
            }
        },
        {
            field: "request_status_name",
            headerName: "Status",
            width: 50,
            cellStyle: { textAlign: "center" },
            displayOrder: _.indexOf(savedCols, _.findWhere(savedCols, { colId: "request_status_name" })) !== -1 ? _.indexOf(savedCols, _.findWhere(savedCols, { colId: "request_status_name" })) : 2,
            cellRenderer: (params) => {
                const pendingId = _.findWhere(dropDownOption?.statusOptions, { request_status_key: "is_pending" })?.request_status_name;
                const approveId = _.findWhere(dropDownOption?.statusOptions, { request_status_key: "is_approved" })?.request_status_name;
                const rejectedId = _.findWhere(dropDownOption?.statusOptions, { request_status_key: "is_rejected" })?.request_status_name;
                const scheduleId = _.findWhere(dropDownOption?.statusOptions, { request_status_key: "is_scheduled" })?.request_status_name;
                const completedId = _.findWhere(dropDownOption?.statusOptions, { request_status_key: "is_completed" })?.request_status_name;
                const failedId = _.findWhere(dropDownOption?.statusOptions, { request_status_key: "is_failed" })?.request_status_name;
                const runningId = _.findWhere(dropDownOption?.statusOptions, { request_status_key: "is_running" })?.request_status_name;
                return (
                    <div style={{ fontSize: "large" }}>
                        {params?.data?.request_status_name === pendingId && <FontAwesomeIcon icon="fa-solid fa-clock" style={{ color: "#d4d404" }} />}
                        {params?.data?.request_status_name === approveId && <FontAwesomeIcon icon="fa-solid fa-check" style={{ color: "green" }} />}
                        {params?.data?.request_status_name === rejectedId && <FontAwesomeIcon icon="fa-solid fa-circle-xmark" style={{ color: "red" }} />}
                        {params?.data?.request_status_name === scheduleId && <FontAwesomeIcon icon="fa-solid fa-calendar-days" style={{ color: "orange" }} />}
                        {params?.data?.request_status_name === completedId && <FontAwesomeIcon icon="fa-solid fa-circle-check" style={{ color: "green" }} />}
                        {params?.data?.request_status_name === failedId && <FontAwesomeIcon icon="fa-solid fa-close" style={{ color: "red" }} />}
                        {params?.data?.request_status_name === runningId && <FontAwesomeIcon icon="fa-solid fa-hourglass" style={{ color: "orange" }} />}
                    </div>
                )
            }
        },
        {
            field: "action",
            headerName: "Action",
            width: 150,
            cellStyle: { textAlign: "center" },
            hide: filterValues?.status?.request_status_key !== 'is_pending' || getValuePermission("helpdesk_action_col"),
            displayOrder: _.indexOf(savedCols, _.findWhere(savedCols, { colId: "action" })) !== -1 ? _.indexOf(savedCols, _.findWhere(savedCols, { colId: "action" })) : 3,
            cellRenderer: (params) => {
                const devOpsUserCodes = _.pluck(approval?.devops_approver, "user_code");
                const pendingName = _.findWhere(dropDownOption?.statusOptions, { request_status_key: "is_pending" })?.request_status_name;
                let showApprove = { val: false, key: "" };
                if (!params?.data?.approve1_datetime && devOpsUserCodes?.includes(dropDownOption?.userCode)) {
                    showApprove = { val: true, key: "approve1" };
                } else if (params?.data?.approve1_datetime && !params?.data?.approve2_datetime && params?.data?.client_user_code === dropDownOption?.userCode) {
                    showApprove = { val: true, key: "approve2" };
                } else {
                    showApprove = { val: false, key: "" };
                }
                return (
                    <div>
                        {(showApprove?.val && params?.data?.request_status_name === pendingName) &&
                            <div className="d-flex gap-2 align-items-baseline justify-content-center ">
                                <label>
                                    <input
                                        type="radio"
                                        value="is_approved"
                                        onChange={(e) => { if (showApprove?.key === "approve2") { setShowApprovePopup(true); setApproval((prevState) => ({ ...prevState, data: params?.data?.build_job_request_ids, status: e?.target?.value, approval_type: showApprove?.key, build_date: new Date((new Date()).getTime() + 8 * 60000) })); } else if (showApprove?.key === "approve1") { handleApproveReject(e?.target?.value, params?.data?.build_job_request_ids, showApprove?.key) } }
                                        }
                                    />
                                    Approve
                                </label>
                                <label>
                                    <input
                                        type="radio"
                                        value="is_rejected"
                                        onChange={(e) => { handleApproveReject(e?.target?.value, params?.data?.build_job_request_ids, showApprove?.key) }
                                        }
                                    />
                                    Reject
                                </label>
                            </div>
                        }
                    </div>
                )
            }
        },
        {
            field: "project_name",
            headerName: "Project",
            width: 120,
            displayOrder: _.indexOf(savedCols, _.findWhere(savedCols, { colId: "project_name" })) !== -1 ? _.indexOf(savedCols, _.findWhere(savedCols, { colId: "project_name" })) : 4,
        },
        {
            field: "project_module_names",
            headerName: "Project Module",
            width: 120,
            displayOrder: _.indexOf(savedCols, _.findWhere(savedCols, { colId: "project_module_names" })) !== -1 ? _.indexOf(savedCols, _.findWhere(savedCols, { colId: "project_module_names" })) : 5,
            cellRenderer: (params) => {
                const allData = params?.value?.split(",");
                const value = params?.value ? allData?.length > 1 ? allData?.join(", ") : params?.value : "";
                const tooltipValue = params?.value ? allData?.length > 1 ? allData?.join("\n") : params?.value : "";
                return <div title={`${tooltipValue}`}>{value}</div>
            }
        },
        {
            field: "build_type_name",
            headerName: "Build Type",
            width: 100,
            displayOrder: _.indexOf(savedCols, _.findWhere(savedCols, { colId: "build_type_name" })) !== -1 ? _.indexOf(savedCols, _.findWhere(savedCols, { colId: "build_type_name" })) : 6,
        },
        {
            field: "job_names",
            headerName: "Services Name",
            width: 180,
            displayOrder: _.indexOf(savedCols, _.findWhere(savedCols, { colId: "job_names" })) !== -1 ? _.indexOf(savedCols, _.findWhere(savedCols, { colId: "job_names" })) : 7,
            cellRenderer: (params) => {
                const allData = params?.value?.split(",");
                const value = params?.value ? allData?.length > 1 ? allData?.join(", ") : params?.value : "";
                const tooltipValue = params?.value ? allData?.length > 1 ? allData?.join("\n") : params?.value : "";
                return <div title={`${tooltipValue}`} onClick={() => setViewPopup((prev) => ({ ...prev, services: true, data: allData }))}>{value}</div>
            }
        },
        {
            field: "requested_user_name",
            headerName: "Request By",
            width: 120,
            displayOrder: _.indexOf(savedCols, _.findWhere(savedCols, { colId: "requested_user_name" })) !== -1 ? _.indexOf(savedCols, _.findWhere(savedCols, { colId: "requested_user_name" })) : 8,
        },
        {
            field: "build_datetime",
            headerName: "Build Date",
            width: filterValues?.status?.request_status_key === 'is_approved' ? 160 : 140,
            cellStyle: { textAlign: "center" },
            displayOrder: _.indexOf(savedCols, _.findWhere(savedCols, { colId: "build_datetime" })) !== -1 ? _.indexOf(savedCols, _.findWhere(savedCols, { colId: "build_datetime" })) : 9,
            hide: filterValues?.status?.request_status_key === 'is_pending' || filterValues?.status?.request_status_key === 'is_rejected',
            cellRenderer: function (params) {
                let showEdit = false;
                const devOpsUserCodes = _.pluck(approval?.devops_approver, "user_code");
                if (filterValues?.status?.request_status_key === "is_approved" && (devOpsUserCodes?.includes(dropDownOption?.userCode) || params?.data?.client_user_code === dropDownOption?.userCode)) {
                    showEdit = true;
                }
                const formattedDate = dateConvert(params?.data?.build_datetime, 'date-time-months')
                return (
                    <div className="d-flex justify-content-between align-items-center">
                        <div>{formattedDate}</div>
                        {showEdit && <div className="c-pointer" onClick={() => { setShowApprovePopup(true); setApproval((prevState) => ({ ...prevState, data: params?.data?.build_job_request_ids, status: "is_approved", approval_type: "approve2", build_date: new Date(params?.data?.build_datetime) })); }}><FontAwesomeIcon icon="fa-solid fa-edit" /></div>}
                    </div>
                )
            }
        },
        {
            field: "devops_user_name",
            headerName: `Approver 1\n(DevOps)`,
            width: 120,
            headerClass: "header-wrap",
            displayOrder: _.indexOf(savedCols, _.findWhere(savedCols, { colId: "devops_user_name" })) !== -1 ? _.indexOf(savedCols, _.findWhere(savedCols, { colId: "devops_user_name" })) : 10,
        },
        {
            field: "approve1_datetime",
            headerName: "Approve 1 Date",
            width: 140,
            cellStyle: { textAlign: "center" },
            displayOrder: _.indexOf(savedCols, _.findWhere(savedCols, { colId: "approve1_datetime" })) !== -1 ? _.indexOf(savedCols, _.findWhere(savedCols, { colId: "approve1_datetime" })) : 11,
            cellRenderer: function (params) {
                const formattedDate = dateConvert(params?.value, 'date-time-months')
                return (
                    <div>{formattedDate}</div>
                )
            }
        },
        {
            field: "client_user_display_name",
            headerName: `Approver 2\n(Client)`,
            width: 120,
            headerClass: "header-wrap",
            displayOrder: _.indexOf(savedCols, _.findWhere(savedCols, { colId: "client_user_display_name" })) !== -1 ? _.indexOf(savedCols, _.findWhere(savedCols, { colId: "client_user_display_name" })) : 12,
        },
        {
            field: "approve2_datetime",
            headerName: "Approve 2 Date",
            width: 140,
            cellStyle: { textAlign: "center" },
            displayOrder: _.indexOf(savedCols, _.findWhere(savedCols, { colId: "approve2_datetime" })) !== -1 ? _.indexOf(savedCols, _.findWhere(savedCols, { colId: "approve2_datetime" })) : 13,
            cellRenderer: function (params) {
                const formattedDate = dateConvert(params?.value, 'date-time-months')
                return (
                    <div>{formattedDate}</div>
                )
            }
        },
        {
            field: "reason",
            headerName: "Reason / Release Notes",
            minWidth: 260,
            displayOrder: _.indexOf(savedCols, _.findWhere(savedCols, { colId: "reason" })) !== -1 ? _.indexOf(savedCols, _.findWhere(savedCols, { colId: "reason" })) : 14,
            cellRenderer: function (params) {
                let reason = params?.value;
                const urlRegex = /(https?:\/\/[^\s]+)/g;

                return <div title={reason} onClick={() => setViewPopup((prev) => ({ ...prev, reason: true, data: [reason] }))}>
                    {reason.split(urlRegex).map((part, index) => {
                        if (part.match(urlRegex)) {
                            return (
                                <a key={index} href={part} target="_blank" className="text-primary" >{part}</a>
                            );
                        }
                        return part
                    })}
                </div>
            },
        },
        {
            field: "apply_datetime",
            headerName: "Requested Date",
            width: 140,
            cellStyle: { textAlign: "center" },
            displayOrder: _.indexOf(savedCols, _.findWhere(savedCols, { colId: "apply_datetime" })) !== -1 ? _.indexOf(savedCols, _.findWhere(savedCols, { colId: "apply_datetime" })) : 15,
            cellRenderer: function (params) {
                const formattedDate = dateConvert(params?.data?.apply_datetime, 'date-time-months')
                return (
                    <div>{formattedDate}</div>
                )
            }
        },
    ];
    const [callJenkinsApi, setCallJenkinsApi] = useState(false);
    const { getAutoBuildJenkinsData, opts } = useProdServiceBuild({ projectOpts: dropDownOption?.projects });
    const [viewPopup, setViewPopup] = useState({ services: false, reason: false, data: [] });

   useEffect(() => {
        callautopopulate("prod_build_request_status", "all_users", "projects", "user_info", "git_roles", "build_type").then((res) => {
            setDropDownOption({
                statusOptions: res?.prod_build_request_status,
                users: _.sortBy(res?.all_users, "user_display_name"),
                projects: res?.projects?.sort((a, b) => a?.project_name?.localeCompare(b?.project_name)),
                userCode: res?.user_info?.[0]?.user_code,
                roleOpts: _.sortBy(res?.body?.data?.git_roles, "request_role_name"),
                build_type: _.sortBy(res?.build_type, "build_type_name"),
                group_wise_status_options: _.groupBy(res?.prod_build_request_status,)
            })
            setFilterValues((prev) => ({ ...prev, status: res?.prod_build_request_status?.[0] }));
        }).catch((error) => {
            console.error("error", error)
        })
    }, [])

    useEffect(() => {
        if (callJenkinsApi) {
            getAutoBuildJenkinsData(filterValues?.project?.[0]?.project_id);
        }
    }, [callJenkinsApi])

    useEffect(() => {
        if (filterValues?.project?.length >= 1) {
            if (!_.isEmpty(opts?.jenkins_type)) {
                setDropDownOption((prev) => ({ ...prev, jenkins_type: opts?.jenkins_type || [] }));
            }
        } else {
            setDropDownOption((prev) => ({ ...prev, jenkins_type: [] }));
        }
    }, [opts, filterValues?.project])

    useEffect(() => {
        filterValues?.status?.request_status_id && filterValues?.apiCall && getRequestedData();
    }, [filterValues?.status?.request_status_id,filterValues?.apiCall])

    const getRequestedData = async (key) => {
        try {
            setLoader((prev) => ({ ...prev, grid: true }));
            if (filterValues?.project?.length === 1) {
                setCallJenkinsApi(true);
            }
            const payload = {
                "project_ids": key === "project" ? "" : _.pluck(filterValues?.projects, "project_id")?.toString() || "",
                "request_status_id": filterValues?.status?.request_status_id || 0,
                "from_date": (filterValues?.hoveredRange && filterValues?.hoveredRange[0] !== undefined) ? dateHoverRange(filterValues?.hoveredRange[0]) : "",
                "to_date": (filterValues?.hoveredRange && filterValues?.hoveredRange[1] !== undefined) ? dateHoverRange(filterValues?.hoveredRange[1]) : "",
                "users": key === "users" ? "" : _.pluck(filterValues?.all_users, "user_code")?.toString() || "",
                "jenkins_type_names": key === "jenkins_type" ? "" : _.pluck(filterValues?.jenkins_type, "jenkins_type_name")?.toString() || "",
                "build_type_ids": key === "build_type" ? "" : _.pluck(filterValues?.build_type, "build_type_id")?.toString() || "",
            }
            const res = await services.getInvokeRemote("POST", Urls("GETAUTOBUILDREQUESTDETAIL"), payload);
            if (res) {
                const data = res?.body?.data?.build_request?.sort((a, b) => new Date(b?.apply_datetime) - new Date(a?.apply_datetime))
                setRowData(data);
                setApproval((prev) => ({ ...prev, "devops_approver": res?.body?.data?.table1 }));
                setLoader((prev) => ({ ...prev, grid: false }));
                  setFilterValues((prev) => ({ ...prev, apiCall: false }))
            }
        } catch (error) {
            console.error("Error: ", error);
            setLoader((prev) => ({ ...prev, grid: false }));
              setFilterValues((prev) => ({ ...prev, apiCall: false }))
        }
    }

    const handleStatusChange = (e) => {
        const data = _.findWhere(dropDownOption?.statusOptions, {
            request_status_id: parseInt(e?.target?.value),
        });
        setFilterValues((prev) => ({ ...prev, ["status"]: data,apiCall:true }));
    };

    const handleApproveReject = async (status, id, approve_by_key) => {
        try {
            if ((approval?.status === "is_approved" && (approval?.data?.length <= 0 || !approval?.data)) || (status === "is_rejected" && (!id || id?.length <= 0))) {
                showInfo("Info", "Please select a request to reject");
                return;
            }

            let expectedDatetime = new Date((new Date()).getTime() + 8 * 60000);
            let buildDate = new Date(approval?.build_date);
            expectedDatetime.setSeconds(0, 0);
            buildDate.setSeconds(0, 0);
            if (approval?.approval_type === "approve2" && status === "is_approved" && (buildDate < expectedDatetime)) {
                showInfo("Info", "Please select build time atleast 8 minutes after current time");
                return;
            }
            setLoader((prev) => ({ ...prev, btn: true }));
            const requestStatus = _.findWhere(dropDownOption?.statusOptions, { request_status_key: status || approval?.status })

            const payload = {
                "build_job_request_ids": id ? id : approval?.data,
                "request_status_id": requestStatus?.request_status_id,
                "is_approver2": approve_by_key === "approve2" ? true : false,
                "build_datetime": (approval?.approval_type === "approve2" && status === "is_approved") ? dateConvert(approval?.build_date, "iso-string") : "",
            }
            const res = await services.getInvokeRemote("POST", Urls("UPSERTAPPROVEAUTOBUILDREQUEST"), payload)
            if (res?.body?.data) {
                showSuccess('Success', res?.body?.message)
                setShowApprovePopup(false)
                getRequestedData()
                setApproval((prevState) => ({ ...prevState, status: '', to_date: null, from_date: null, build_date: null, key: "" }))
                setLoader((prev) => ({ ...prev, btn: false }));
            }
            else {
                showError("Error", res?.body?.errorMessage);
                if (res?.body?.StatusCode === 202) {
                    getRequestedData();
                }
                setLoader((prev) => ({ ...prev, btn: false }));
            }
        } catch (error) {
            console.error("Error", error);
            showError("Error", error?.response?.data?.errorMessage);
            setLoader((prev) => ({ ...prev, btn: false }));
        }
    }

    const gridRef = useRef(null);

    const onColumnMoved = useCallback(() => {
        if (!gridRef.current) return;
        const columnState = gridRef.current.api?.getColumnState();
        localStorage.setItem("prod_build_column_order", JSON.stringify(columnState));
    }, []);

    const onGridReady = useCallback((params) => {
        gridRef.current = params;
        setTimeout(() => {
            const savedState = localStorage.getItem("prod_build_column_order");
            if (savedState) {
                try {
                    params.api.applyColumnState({
                        state: JSON.parse(savedState)?.map((item) => item["hide"] = false),
                        applyOrder: true
                    });
                } catch (err) {
                    console.error(err);
                }
            }
        }, 100);
    }, []);

    return useMemo(() => ({
        tagRef, dropDownOption, filterValues, setFilterValues, showRequestPopup, setShowRequestPopup, editData, setEditData, getRequestedData, rowData, columnDef, handleStatusChange, loader, setCallJenkinsApi, showApprovePopup, setShowApprovePopup, approval, setApproval, handleApproveReject, viewPopup, setViewPopup, gridRef, onColumnMoved, onGridReady
    }), [tagRef, dropDownOption, filterValues, setFilterValues, showRequestPopup, setShowRequestPopup, editData, setEditData, getRequestedData, rowData, columnDef, handleStatusChange, loader, setCallJenkinsApi, showApprovePopup, setShowApprovePopup, approval, setApproval, handleApproveReject, viewPopup, setViewPopup, gridRef, onColumnMoved, onGridReady])
}